export default "__VITE_ASSET__daad19e8__"